import { Figure, Corner, SectionHead } from "./Primitives";
import { Illu } from "./Illustrations";

/** Six curated works. Slight asymmetry: the first card runs taller and wider. */
export const Works = ({ texts, works }) => (
  <section id="arbeiten" data-testid="works-section" className="relative border-b border-paper-line ap-section">
    <div className="ap-container">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <SectionHead stamp="AP · ARCHIV 01–06" title={texts.works_h2} intro={texts.works_intro} />
        <div className="ap-illu hidden h-24 w-24 shrink-0 lg:block" aria-hidden="true">
          <Illu name={texts.illu_works} fallback="prints" className="h-full w-full" />
        </div>
      </div>

      <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {works.map((w, i) => (
          <article
            key={w.id}
            data-testid={`work-card-${i}`}
            className={`ap-card group flex flex-col animate-rise ${
              i === 0 ? "sm:col-span-2 lg:col-span-2" : ""
            }`}
            style={{ animationDelay: `${i * 60}ms` }}
          >
            <Corner />
            <Figure
              src={w.image}
              mediaId={w.image_media_id}
              alt={`${w.title} – Tattoo von René Ghavami, ${w.placement}`}
              code={w.code}
              ratio={i === 0 ? "aspect-[16/10]" : "aspect-[4/5]"}
            />
            <div className="flex flex-1 flex-col gap-2 p-5">
              <div className="flex items-baseline justify-between gap-3">
                <h3 className="font-display text-lg font-bold uppercase tracking-wide text-ink">{w.title}</h3>
                <span className="ap-stamp shrink-0">{w.code}</span>
              </div>
              <p className="ap-stamp">
                {w.category} · {w.placement}
              </p>
              {w.description ? <p className="ap-body mt-1 text-charcoal">{w.description}</p> : null}
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
